import { Component, Input, ElementRef, EventEmitter,ViewChild, OnInit,Output, AfterViewInit, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'app-scora-audio-view',
  templateUrl: './scora-audio-view.component.html',
  styleUrls: ['./scora-audio-view.component.css']
})
export class ScoraAudioViewComponent implements OnInit {

  @Input() selectedData:any;
  @Input() uploadStatus:any = true;

  @ViewChild('audioPlayer',) audioPlayer: ElementRef;
  
  @Output() audioPlay: EventEmitter<any> = new EventEmitter<any>();

  // Static property to hold the reference to the currently playing audio element
  private static currentAudio: HTMLAudioElement | null = null;





    // Get a reference to the <audio> element from the template
  @ViewChild('audioPlayer') audioPlayerRef: ElementRef;
  private audio: HTMLAudioElement;

  // State properties
  isPlaying = false;
  isMuted = false;
  duration = 0;
  currentTime = 0;
  volume = 0.75; // Initial volume set to 75%

  // Properties for dynamically styling the slider track gradients
  volumePercent = '75%';
  progressPercent = '0%';
  
  lastVolume: number = 1; // store last non-zero volume (1 = 100%)
  @ViewChild('volumeSlider') volumeSliderRef: ElementRef;
  constructor(private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
  }
  playAudio() {
    const audioElement = this.audioPlayer.nativeElement as HTMLAudioElement; // Cast native element as HTMLAudioElement

    // Stop the currently playing audio if it's different from this one
    if (ScoraAudioViewComponent.currentAudio && ScoraAudioViewComponent.currentAudio !== audioElement) {
      ScoraAudioViewComponent.currentAudio.pause();
      ScoraAudioViewComponent.currentAudio.currentTime = 0; // Reset the previous audio to start
    }

    // Set this audio as the currently playing audio
    ScoraAudioViewComponent.currentAudio = audioElement;
    audioElement.play();
  }








  ngAfterViewInit() {
    this.audio = this.audioPlayerRef.nativeElement;
    this.audio.volume = this.volume;

     

        // Set default 50% fill for *this instance only*
      const volumeSlider = this.volumeSliderRef.nativeElement;
      volumeSlider.style.setProperty('--volume-percent', this.volumePercent);
      volumeSlider.value = String(this.volume * 100);


    this.addEventListeners();
  }

  // --- Time Formatting Logic (moved from pipe) ---
  formatTime(seconds: number): string {
    if (isNaN(seconds) || seconds === null) {
      return '00:00';
    }
    const minutes: number = Math.floor(seconds / 60);
    const remainingSeconds: number = Math.floor(seconds % 60);

    const formattedMinutes = ('0' + minutes).slice(-2);
    const formattedSeconds = ('0' + remainingSeconds).slice(-2);
    
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  private addEventListeners() {
    this.audio.addEventListener('loadedmetadata', () => {
      this.duration = this.audio.duration;
      this.cdRef.detectChanges();
    });

    this.audio.addEventListener('timeupdate', () => {
     this.currentTime = this.audio.currentTime;

      // Update progressPercent dynamically
      this.progressPercent = `${(this.currentTime / this.duration) * 100}%`;

      // Update CSS variable for the slider track
      const progressSlider = this.audioPlayerRef.nativeElement.nextElementSibling.querySelector('.progress-bar') as HTMLInputElement;
      if (progressSlider) {
        progressSlider.style.setProperty('--progress-percent', this.progressPercent);
      }

      this.cdRef.detectChanges();
    });

    this.audio.addEventListener('volumechange', () => {
      this.isMuted = this.audio.muted;
      this.volume = this.audio.volume;
      this.volumePercent = this.isMuted ? '0%' : `${this.volume * 100}%`;
      this.cdRef.detectChanges();
    });

    this.audio.addEventListener('play', () => { this.isPlaying = true; });
    this.audio.addEventListener('pause', () => { this.isPlaying = false; });
    this.audio.addEventListener('ended', () => {
      this.isPlaying = false;
      this.audio.currentTime = 0; // Reset audio to the beginning
    });
  }

  // togglePlayPause() {
  //   this.isPlaying ? this.audio.pause() : this.audio.play();
    
  // }

  togglePlayPause() {
    if (this.isPlaying) {
      this.audio.pause();
    } else {
      // Agar koi purana audio play ho raha hai aur wo current audio nahi hai, to use pause karein
      if (ScoraAudioViewComponent.currentAudio && ScoraAudioViewComponent.currentAudio !== this.audio) {
        ScoraAudioViewComponent.currentAudio.pause();
        // ScoraAudioViewComponent.currentAudio.currentTime = 0; // (Optional) Agar aap chahte hain ki purana audio shuru se start ho
      }

      // Is current audio ko static variable mein save karein
      ScoraAudioViewComponent.currentAudio = this.audio;
      
      // Current audio ko play karein
      this.audio.play();
    }
    this.audioPlay.emit(this.isPlaying)
  }
  
  // toggleMute() {
  //   this.audio.muted = !this.audio.muted;
  // }



  toggleMute() {
    const slider = this.volumeSliderRef.nativeElement;

    // If currently NOT muted → now mute
    if (!this.isMuted) {
      this.lastVolume = this.audio.volume || 1;

      this.audio.muted = true;
      this.audio.volume = 0;

      this.isMuted = true;

      // Update UI slider
      slider.value = 0;
      slider.style.setProperty('--volume-percent', '0%');

      this.volume = 0;
      this.volumePercent = '0%';
    }
    else {
      // Unmute
      this.audio.muted = false;
      this.audio.volume = this.lastVolume;

      this.isMuted = false;

      const percent = this.lastVolume * 100;

      // Update UI slider
      slider.value = percent;
      slider.style.setProperty('--volume-percent', percent + '%');

      this.volume = this.lastVolume;
      this.volumePercent = percent + '%';
    }

    // this.audio.muted = !this.audio.muted;
  }


  // Fired when the user drags the progress bar
 onProgressChange(event: any) {
  const value = event.target.value;
  this.audio.currentTime = value;

  // Update the CSS variable for progress fill
  this.progressPercent = `${(value / this.duration) * 100}%`;
  event.target.style.setProperty('--progress-percent', this.progressPercent);
}

  // Fired when the user drags the volume slider
onVolumeChange(event: any) {
  const value = event.target.value;
  this.audio.muted = false; // Unmute if user changes volume
  this.audio.volume = value / 100;

  // Update the CSS variable for slider fill
  this.volumePercent = `${value}%`;
  event.target.style.setProperty('--volume-percent', this.volumePercent);
}


}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-audio-view/scora-audio-view.component.ts